export enum TripType {
  truckTrailer = 1,
  straightTruck = 2,
  commercialVan = 3
}
